import React from 'react';

/** Shared loading/empty/content pattern to eliminate nested ternaries */
export function ContentState({ loading, empty, emptyContent, children }) {
  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="spinner"></div>
      </div>
    );
  }
  if (empty) {
    return emptyContent;
  }
  return children;
}
